import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ATMWarningPopup.css";
import BankLogo from "../assets/photos/bank-logo.png"

const ATMWarningPopup = () => {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const popupShown = sessionStorage.getItem("popupShown");

        if (!popupShown) {
            setShow(true);
            sessionStorage.setItem("popupShown", "true");
        }
    }, []);

    if (!show) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-box">

                <h4><b>Stay Protected from Cyber Fraud</b></h4>

                <img src={BankLogo} alt="Bank Logo" className="popup-logo" />
                <h2>The Sahyadri Sahakari Bank Ltd Mumbai</h2>

                <ul>
                    <li>Don't Let Strangers Assist You at the ATM</li>
                    <li>Don't Ignore Unusual ATM Behaviour</li>
                    <li>Don't Save Payment Information on Untrusted Websites</li>
                    <li>Don't Click on Suspicious Links</li>
                    <li>Don't Share Card Details Over the Phone</li>
                </ul>

                <button
                    className="details-btn"
                    onClick={() => navigate("/dosdonts")}
                >
                    For more details click here
                </button>

                <button
                    className="close-btn"
                    onClick={() => setShow(false)}
                >
                    Close
                </button>

            </div>
        </div>
    );
};

export default ATMWarningPopup;